import { createContext, useContext } from "react";

export type FormSheetContextValue = {
  openImageMode?: () => void;
  hasPictures?: boolean;
};

export const FormSheetContext = createContext<FormSheetContextValue>({});

export const useFormSheetContext = () => useContext(FormSheetContext);
